import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseCarouselComponent } from './course-carousel.component';
import { CarouselModule } from 'ng-carousel-cdk';
import { CourseCardModule } from '../course-card/course-card.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [CourseCarouselComponent],
  imports: [
    CourseCardModule,
    MatButtonModule,
    CommonModule,
    CarouselModule
  ],
  exports: [CourseCarouselComponent],
})
export class CourseCarouselModule { }
